
import React from 'react';
import { Globe, MapPin, CheckCircle2, ArrowLeft } from 'lucide-react';

interface Props {
  onSelect: (country: string) => void;
  selected: string | null;
  onConfirm: () => void;
  t: any;
}

const CountrySelector: React.FC<Props> = ({ onSelect, selected, onConfirm, t }) => {
  const countries = [
    { id: 'Kurdistan', label: t.country_kurdistan, icon: '☀️' },
    { id: 'Iran', label: t.country_iran, icon: '🦁' },
    { id: 'Iraq', label: t.country_iraq, icon: '🌴' },
    { id: 'Other', label: t.country_other, icon: '🌍' },
  ];

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6 animate-fade-in bg-slate-50">
      <div className="text-center mb-10">
        <div className="w-20 h-20 bg-indigo-100 rounded-3xl flex items-center justify-center mx-auto mb-6">
            <Globe className="w-10 h-10 text-indigo-600" />
        </div>
        <h1 className="text-3xl font-black text-slate-800 mb-2">{t.select_country}</h1>
        <p className="text-slate-500 max-w-md mx-auto">ناوەرۆکی ئەپەکە بەپێی کلتوور و ئەدەبیاتی وڵاتەکەت ڕێکدەخرێت.</p>
      </div>

      <div className="grid grid-cols-2 gap-4 w-full max-w-md mb-10">
        {countries.map((c) => (
          <button
            key={c.id}
            onClick={() => onSelect(c.id)}
            className={`p-6 rounded-[2rem] border-2 transition-all flex flex-col items-center gap-3
              ${selected === c.id 
                ? 'border-indigo-500 bg-indigo-50 shadow-lg scale-[1.05]' 
                : 'border-slate-100 bg-white hover:border-slate-200'
              }`}
          >
            <span className="text-4xl">{c.icon}</span>
            <span className="font-bold text-slate-700">{c.label}</span>
            {selected === c.id && <CheckCircle2 className="w-5 h-5 text-indigo-500" />}
          </button>
        ))}
      </div>

      <button
        onClick={onConfirm}
        disabled={!selected}
        className="w-full max-w-md bg-indigo-600 text-white py-4 rounded-2xl font-black text-lg hover:bg-indigo-700 disabled:opacity-50 transition-all shadow-xl shadow-indigo-500/20 flex items-center justify-center gap-3"
      >
        {t.continue}
        <ArrowLeft className="w-5 h-5 rtl:rotate-180" />
      </button>
    </div>
  );
};

export default CountrySelector;
